import { Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'app-static-footer',
  imports: [MatIcon, NgTemplateOutlet],
  template: `
    <footer class="text-white">
      <div class="grid gap-y-5">
        <div class="flex items-center body-2 leading-16!">
          <div>
            <span class="text-red">Need assistance with EstImage?</span>
            Please contact Stelvio Support at
          </div>

          <ng-container
            [ngTemplateOutlet]="contact"
            [ngTemplateOutletContext]="{
              link: 'tel:+0294551055',
              icon: 'phone_in_talk',
              text: '02 9455 1055'
            }">
          </ng-container>

          <ng-container
            [ngTemplateOutlet]="contact"
            [ngTemplateOutletContext]="{
              link: 'mailto:ozsupport@stelvio.com.au',
              icon: 'email',
              text: 'ozsupport@stelvio.com.au'
            }">
          </ng-container>
        </div>

        <div class="text-charcoal-80 legal">
          All contents Copyright &copy; 1990-{{ currentYear }} Stelvio Inc. All Rights Reserved. build.6.7b651
        </div>
      </div>

      <div class="logo">
        <a href="http://www.stelvio.com" rel="noopener" target="_blank">
          <img src="assets/images/stelvio_footer.svg" width="27px" height="32px" />
        </a>
      </div>
    </footer>

    <ng-template #contact let-link="link" let-icon="icon" let-text="text">
      <div class="grid grid-cols-[16px_auto] gap-x-5 items-center ml-10">
        <a [href]="link" class="h-16">
          <mat-icon class="size-16! text-16! text-red!">{{ icon }}</mat-icon>
        </a>
        {{ text }}
      </div>
    </ng-template>
  `
})
export class StaticFooterComponent {
  currentYear = new Date().getFullYear();
}
